<div class="app-versions-page">
  <div class="app-versions-header">
    <div>
      <h1>App Versions</h1>
      <p>Control Android and iOS mobile update requirements.</p>
    </div>
  </div>

  @if (message) {
    <div class="app-version-message">{{ message }}</div>
  }

  @if (error) {
    <div class="app-version-error">{{ error }}</div>
  }

  @if (loading) {
    <div class="app-version-loading">
      <i class="ri-loader-4-line spin"></i>
      Loading...
    </div>
  }

  @if (!loading) {
    <div class="version-grid">
      @for (policy of policies; track policy.platform) {
        <section class="version-card">
          <div class="version-card-header">
            <div>
              <h2>{{ getPlatformLabel(policy.platform) }}</h2>
              <p>{{ getBuildLabel(policy.platform) }} controls force update enforcement.</p>
            </div>
            <span class="status-pill" [class.inactive]="!policy.isActive">
              {{ policy.isActive ? 'Active' : 'Inactive' }}
            </span>
          </div>

          <div class="field">
            <label [for]="policy.platform + '-display-version'">Display Version</label>
            <input
              [id]="policy.platform + '-display-version'"
              type="text"
              [(ngModel)]="policy.displayVersion"
              placeholder="1.1.9" />
          </div>

          <div class="field">
            <label [for]="policy.platform + '-build-number'">{{ getBuildLabel(policy.platform) }}</label>
            <input
              [id]="policy.platform + '-build-number'"
              type="number"
              min="1"
              [(ngModel)]="policy.buildNumber" />
          </div>

          <div class="field">
            <label [for]="policy.platform + '-store-url'">Store URL</label>
            <input
              [id]="policy.platform + '-store-url'"
              type="url"
              [(ngModel)]="policy.storeUrl"
              placeholder="https://..." />
          </div>

          <div class="toggle-row">
            <label>
              <input type="checkbox" [(ngModel)]="policy.forceUpdate" />
              Force update
            </label>
            <label>
              <input type="checkbox" [(ngModel)]="policy.isActive" />
              Active
            </label>
          </div>

          <button
            type="button"
            class="save-btn"
            (click)="save(policy)"
            [disabled]="savingPlatform === policy.platform">
            <i class="ri-save-line"></i>
            {{ savingPlatform === policy.platform ? 'Saving...' : 'Save' }}
          </button>
        </section>
      }
    </div>
  }
</div>
